import {
  getAPIUrl,
  downloadCSV,
} from '../helpers/App';

export const APIgetReport = params => (
  window.axios.post(getAPIUrl('/reports'), params)
    .then((response) => {
      if (params.csv) {
        const fileName = response.headers['content-disposal'] || 'report.csv';
        return downloadCSV(response.data, fileName);
      }
      return response.data;
    })
);

export const APIgetReportsSettings = () => (
  window.axios.get(getAPIUrl('/reports/settings'))
    .then(response => (response.data))
);
